export function getSevenDay(){
    let weeks = [];
    let date = new Date();
    for (let i = 0; i < 7; i++){
        let day = date.getDate()
        weeks[i] = (day < 10 ? '0' + day : day) + "日";
        date.setDate(day + 1);
    }
    return weeks;
}
